import { render } from "./CookieConsentBanner.vue?vue&type=template&id=64fe2bb6&scoped=true"
import script from "./CookieConsentBanner.vue?vue&type=script&lang=js"
export * from "./CookieConsentBanner.vue?vue&type=script&lang=js"

import "./CookieConsentBanner.vue?vue&type=style&index=0&id=64fe2bb6&scoped=true&lang=css"

import exportComponent from "/Users/k.belov/Programming/sites/gl_site/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64fe2bb6"]])

export default __exports__